import { render, staticRenderFns } from "./KarmaRequestAddForm.vue?vue&type=template&id=23dfff80&scoped=true&"
import script from "./KarmaRequestAddForm.vue?vue&type=script&lang=js&"
export * from "./KarmaRequestAddForm.vue?vue&type=script&lang=js&"
import style0 from "./KarmaRequestAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KarmaRequestAddForm.vue?vue&type=style&index=1&id=23dfff80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dfff80",
  null
  
)

export default component.exports